import { SVGProps } from "react";

export const Trophy = (props: SVGProps<SVGSVGElement>) => {
  const svgProps = {
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 256 256",
    ...props,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <path d="M232,64H208V56a16,16,0,0,0-16-16H64A16,16,0,0,0,48,56v8H24A16,16,0,0,0,8,80V96a40,40,0,0,0,40,40h3.65A80.13,80.13,0,0,0,120,191.61V216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V191.58c31.94-3.23,58.44-25.64,68.08-55.58H208a40,40,0,0,0,40-40V80A16,16,0,0,0,232,64ZM48,120A24,24,0,0,1,24,96V80H48v32q0,4,.39,8ZM232,96a24,24,0,0,1-24,24h-.5a81.81,81.81,0,0,0,.5-8.9V80h24Z"></path>
    </svg>
  );
};

export const Tray = (props: SVGProps<SVGSVGElement>) => {
  const svgProps = {
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 256 256",
    ...props,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,16V152h-28.7A15.86,15.86,0,0,0,168,156.69L148.69,176H107.31L88,156.69A15.86,15.86,0,0,0,76.69,152H48V48Zm0,160H48V168H76.69L96,187.31A15.86,15.86,0,0,0,107.31,192h41.38A15.86,15.86,0,0,0,160,187.31L179.31,168H208v40Z"></path>
    </svg>
  );
};

export const Profile = (props: SVGProps<SVGSVGElement>) => {
  const svgProps = {
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 256 256",
    ...props,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <path d="M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"></path>
    </svg>
  );
};

export const ServiceLogo1Line = (props: SVGProps<SVGSVGElement>) => {
  const svgProps = {
    width: 277,
    height: 20,
    fill: "none",
    viewBox: "0 0 277 20",
    ...props,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <path
        d="M93.4699 19.6237L87.2961 5.8763L87.2048 5.67224L80.775 19.4787L80.707 19.6237H83.0162L84.441 16.5145H89.7878L91.1304 19.6237H93.4699ZM87.1672 10.4964L88.9125 14.4953H85.3396L87.1672 10.4964Z"
        fill="#040000"
      />
      <path
        d="M96.9443 6.61914H94.8088V19.6237H96.9443V6.61914Z"
        fill="#040000"
      />
      <path
        d="M21.3336 10.9224H26.5176V8.95871H21.2244L21.0812 6.38464H19.1158L19.259 8.95871H14.4492V10.9224H19.3682L19.5185 13.6396H13.7708V15.6033H19.6295L19.8479 19.5306H21.8134L21.595 15.6033H27.1942V13.6396H21.4858L21.3336 10.9224Z"
        fill="#040000"
      />
      <path
        d="M8.54023 13.4463C8.98416 12.7876 9.37976 12.0948 9.71807 11.3681C10.699 9.38112 10.8619 7.31543 10.8619 7.31543H0.748232V9.27909H8.45073C7.08494 13.2064 3.96492 16.2727 0 17.5633V19.6129C2.85152 18.8128 5.34861 17.2215 7.25678 15.0895C7.41072 15.3079 7.59331 15.5496 7.81169 15.8073C8.98774 17.1946 10.6381 18.4691 12.7146 19.6022V17.3378C9.96689 15.6498 8.88571 14.0674 8.54023 13.4463Z"
        fill="#040000"
      />
      <path
        d="M57.2218 11.7744H55.3423L55.7325 14.4129H57.6138L57.2218 11.7744Z"
        fill="#040000"
      />
      <path
        d="M60.2578 14.4129L59.8675 11.7744H57.9862L58.3782 14.4129H60.2578Z"
        fill="#040000"
      />
      <path
        d="M57.3097 17.6332V19.5235C61.1188 18.9113 64.0688 15.6999 64.28 11.7744H62.4148C62.2143 14.6743 60.0878 17.0514 57.3079 17.6332H57.3097Z"
        fill="#040000"
      />
      <path
        d="M30.3947 7.31543C30.3947 8.62931 30.3947 11.599 30.3589 13.4821C30.3392 14.5865 29.6393 16.3354 28.363 17.3289V19.604C31.0373 18.4333 32.2868 15.3401 32.3208 13.5179C32.3566 11.6205 32.3584 8.63647 32.3566 7.31543H30.3929H30.3947Z"
        fill="#040000"
      />
      <path
        d="M35.8597 17.379V7.31543H33.896V19.5145L34.8805 19.5109C34.9503 19.5109 36.6312 19.493 38.3353 18.376C39.6778 17.4953 41.2763 15.7644 41.7918 12.4224H39.8013C39.1605 15.9022 37.1055 17.0192 35.8597 17.379Z"
        fill="#040000"
      />
      <path
        d="M75.5374 6.31482C74.7695 6.31482 74.0929 6.714 73.7026 7.31545H63.7V9.27911H73.0439C73.0439 9.31849 73.0475 9.35787 73.0475 9.39904C73.0475 13.8938 69.5301 17.5508 65.2072 17.5508V19.5145C70.2174 19.5145 74.3596 15.6158 74.9395 10.6037C75.1293 10.6574 75.3298 10.6897 75.5374 10.6897C76.7439 10.6897 77.723 9.70872 77.723 8.50224C77.723 7.29576 76.7421 6.31482 75.5374 6.31482ZM75.5374 9.17708C75.1651 9.17708 74.8608 8.87456 74.8608 8.50045C74.8608 8.12633 75.1633 7.82381 75.5374 7.82381C75.9115 7.82381 76.214 8.12633 76.214 8.50045C76.214 8.87456 75.9115 9.17708 75.5374 9.17708Z"
        fill="#040000"
      />
      <path
        d="M42.0711 7.31543V9.27909H52.2367C51.8822 11.6455 50.6901 12.895 48.4167 13.2977C48.5689 12.3866 48.5957 11.5274 48.5438 10.8346H46.6929L46.5748 10.8454C46.5748 10.8597 46.7108 12.3794 46.2365 14.0101C45.7353 15.7375 44.7615 16.9189 43.3366 17.5365V19.6237C45.7496 18.8862 47.1225 17.1749 47.8493 15.3491C51.3936 15.0126 53.4288 13.2351 54.1198 10.0524C54.4688 8.44494 54.3543 7.31543 54.3543 7.31543H42.0675H42.0711Z"
        fill="#040000"
      />
      <path
        d="M105.54 1.16528V4.24413H120.666V16.9193H105.54V20H124.228V1.16528H105.54Z"
        fill="url(#paint0_radial_252_2453)"
      />
      <path
        d="M135.682 8.23588L137.669 5.38078C137.669 5.38078 135.953 4.16177 134.664 3.39564C133.387 2.63666 130.599 1.24402 130.599 1.24402L128.739 4.12418C128.739 4.12418 131.486 5.54367 132.761 6.2919C134.037 7.04014 135.682 8.23408 135.682 8.23408V8.23588Z"
        fill="url(#paint1_radial_252_2453)"
      />
      <path
        d="M145.996 3.19694L145.907 3.17725L145.889 3.26675C145.476 5.3396 144.831 7.17259 143.977 8.71381C143.125 10.2514 142.032 11.5743 140.727 12.6376C139.418 13.708 137.837 14.569 136.03 15.1991C134.22 15.8292 132.084 16.2624 129.682 16.4861L129.585 16.4951L130.135 19.7332L130.148 19.8138L130.232 19.8066C133.862 19.4844 137.019 18.6861 139.613 17.4313C142.207 16.1747 144.321 14.4097 145.896 12.1829C147.468 9.95609 148.549 7.19586 149.111 3.97739L149.127 3.89326L145.996 3.19694Z"
        fill="url(#paint2_radial_252_2453)"
      />
      <path
        d="M172.768 16.2714C171.225 14.6926 169.818 13.2355 168.469 11.8142C167.076 10.3518 165.621 8.79801 164.024 7.06884C163.421 6.38505 162.882 5.81582 162.424 5.37189C161.96 4.92438 161.568 4.59323 161.228 4.36231C160.884 4.12245 160.528 3.95956 160.172 3.87722C159.819 3.79488 159.416 3.75549 158.978 3.75549C158.521 3.75549 158.106 3.81814 157.743 3.94166C157.379 4.06338 157.018 4.27281 156.663 4.55922C156.309 4.84562 155.928 5.24659 155.525 5.74601C155.122 6.24006 154.657 6.88267 154.096 7.70609C153.5 8.52771 152.838 9.44421 152.115 10.4484C151.427 11.4043 150.615 12.5141 149.627 13.8423L149.577 13.9103L152.106 16.0423L152.179 16.1049L152.235 16.0261C153.119 14.8107 153.912 13.7009 154.592 12.7253C155.29 11.7229 155.886 10.8494 156.416 10.0546C156.998 9.21866 157.406 8.64764 157.696 8.25742C157.995 7.85287 158.246 7.58079 158.439 7.44296C158.81 7.17445 159.137 7.1834 159.549 7.42148C159.753 7.5432 160.032 7.78306 160.376 8.13212C160.718 8.48117 161.18 8.98775 161.785 9.67512C162.61 10.6274 163.473 11.5905 164.35 12.541C165.214 13.4771 166.149 14.4778 167.13 15.5124C168.034 16.4701 169.014 17.5047 170.069 18.6181L170.411 18.9779L172.77 16.3949L172.825 16.3322L172.768 16.2714Z"
        fill="url(#paint3_radial_252_2453)"
      />
      <path
        d="M167.291 6.78783C167.81 7.09751 168.386 7.25503 169.004 7.25503C169.621 7.25503 170.199 7.09751 170.715 6.78783C171.231 6.47816 171.646 6.05929 171.948 5.54197C172.251 5.02465 172.405 4.44826 172.405 3.8307C172.405 3.21314 172.256 2.63317 171.959 2.11943C171.666 1.60033 171.254 1.18504 170.737 0.882523C170.217 0.580008 169.634 0.427856 169.002 0.427856C168.384 0.427856 167.808 0.580008 167.289 0.882523C166.773 1.18325 166.356 1.60032 166.045 2.11764C165.735 2.63496 165.578 3.2024 165.578 3.80743C165.578 4.44289 165.735 5.02465 166.045 5.54197C166.355 6.05929 166.773 6.47637 167.289 6.78783H167.291ZM168.148 2.97328C168.383 2.74057 168.662 2.6278 169.004 2.6278C169.342 2.6278 169.628 2.74415 169.858 2.97328C170.087 3.2024 170.203 3.4906 170.203 3.82891C170.203 4.1726 170.09 4.45184 169.858 4.68455C169.628 4.91367 169.34 5.03002 169.004 5.03002C168.662 5.03002 168.383 4.91725 168.148 4.68455C167.915 4.45184 167.803 4.1726 167.803 3.82891C167.803 3.48881 167.919 3.2024 168.148 2.97328Z"
        fill="url(#paint4_radial_252_2453)"
      />
      <path
        d="M176.309 6.83789V9.91674H186.168V10.3105C186.168 12.2241 185.572 13.7528 184.396 14.8501C183.217 15.9491 181.425 16.6455 179.071 16.9158L178.969 16.9283L179.717 19.9248L179.737 20L179.812 19.9928C181.894 19.8156 183.695 19.3162 185.166 18.5089C186.639 17.698 187.783 16.5846 188.56 15.1991C189.338 13.8172 189.73 12.1722 189.73 10.3105V9.91674H197.947V6.83789H176.309Z"
        fill="url(#paint5_radial_252_2453)"
      />
      <path
        d="M195.434 0H178.824V3.07885H195.434V0Z"
        fill="url(#paint6_radial_252_2453)"
      />
      <path
        d="M212.1 5.16248L211.873 5.41129C211.196 6.13983 210.368 6.85942 209.41 7.545C208.46 8.22701 207.414 8.86605 206.306 9.44602C205.22 10.0117 204.085 10.5021 202.937 10.8977C201.802 11.2862 200.703 11.5618 199.663 11.7194L199.37 11.7677L199.849 14.7051L200.141 14.6657C201.332 14.485 202.574 14.1735 203.836 13.7349C204.459 13.5201 205.082 13.2803 205.694 13.0207V20H208.968V11.3828C209.687 10.9693 210.393 10.5182 211.064 10.0457C212.14 9.2885 213.08 8.49014 213.853 7.67568L214.043 7.48415L212.1 5.16427V5.16248Z"
        fill="url(#paint7_radial_252_2453)"
      />
      <path
        d="M221.053 3.83067C221.921 4.04906 222.826 4.29787 223.745 4.56637C224.676 4.84025 225.649 5.14455 226.641 5.47213L226.725 5.50077L227.702 2.57586L227.617 2.54722C226.641 2.21428 225.673 1.91176 224.738 1.63968C223.8 1.36759 222.884 1.11878 222.016 0.900393C221.119 0.67485 220.161 0.463626 219.171 0.272093L219.094 0.255981L218.128 3.08423L218.092 3.18268L218.194 3.20237C219.196 3.39211 220.157 3.60334 221.053 3.83067Z"
        fill="url(#paint8_radial_252_2453)"
      />
      <path
        d="M221.922 10.0403C222.83 10.3016 223.782 10.6042 224.758 10.9335L224.842 10.964L225.837 8.12497L225.869 8.03904L225.782 8.00861C224.79 7.67746 223.822 7.37673 222.903 7.1136C221.98 6.85046 221.088 6.61597 220.254 6.41191C219.391 6.20247 218.475 5.99125 217.533 5.78182L217.455 5.76392L216.534 8.59574L216.504 8.6924L216.602 8.71209C217.567 8.909 218.477 9.11843 219.304 9.32966C220.136 9.53909 221.017 9.77895 221.924 10.0385L221.922 10.0403Z"
        fill="url(#paint9_radial_252_2453)"
      />
      <path
        d="M234.157 3.27759L234.145 3.36888C233.858 5.58673 233.316 7.52891 232.536 9.14352C231.753 10.751 230.69 12.1024 229.369 13.1603C228.048 14.22 226.412 15.0309 224.507 15.5733C222.597 16.1157 220.315 16.4236 217.727 16.488H217.623L218.135 19.7387L218.215 19.7351C222.152 19.6062 225.497 18.9529 228.155 17.7947C230.819 16.633 232.937 14.8806 234.454 12.5911C235.969 10.3035 236.973 7.37138 237.442 3.87904L237.453 3.79133L234.157 3.27759Z"
        fill="url(#paint10_radial_252_2453)"
      />
      <path
        d="M239.83 8.06592V10.5666H249.757V12.6394H240.489V15.0972H249.757V17.4994H239.83V20H252.629V8.06592H239.83Z"
        fill="url(#paint11_radial_252_2453)"
      />
      <path
        d="M262.635 8.23588L264.622 5.38078C264.622 5.38078 262.905 4.16177 261.616 3.39564C260.34 2.63666 257.551 1.24402 257.551 1.24402L255.691 4.12418C255.691 4.12418 258.439 5.54367 259.714 6.2919C260.99 7.04014 262.635 8.23408 262.635 8.23408V8.23588Z"
        fill="url(#paint12_radial_252_2453)"
      />
      <path
        d="M272.949 3.19694L272.86 3.17725L272.842 3.26675C272.428 5.3396 271.784 7.17259 270.93 8.71381C270.078 10.2514 268.984 11.5743 267.679 12.6376C266.371 13.708 264.79 14.569 262.982 15.1991C261.172 15.8292 259.037 16.2624 256.635 16.4861L256.538 16.4951L257.088 19.7332L257.1 19.8138L257.184 19.8066C260.814 19.4844 263.972 18.6861 266.566 17.4313C269.16 16.1747 271.274 14.4097 272.849 12.1829C274.42 9.95609 275.502 7.19586 276.064 3.97739L276.08 3.89326L272.949 3.19694Z"
        fill="url(#paint13_radial_252_2453)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60872) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="0.134" stopColor="#83E2E1" />
          <stop offset="0.288" stopColor="#79D4D5" />
          <stop offset="0.452" stopColor="#68BDC2" />
          <stop offset="0.623" stopColor="#509DA7" />
          <stop offset="0.8" stopColor="#317385" />
          <stop offset="0.978" stopColor="#0D415B" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60875) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60875) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60869) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60866) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60872) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.6087) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60867) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60869) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60868) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60865) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60866) scale(20.2398 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.854 -3.60875) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_252_2453"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.853 -3.60875) scale(20.2399 20.2399)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const ServiceLogo = (props: SVGProps<SVGSVGElement>) => {
  const svgProps = {
    width: 301,
    height: 74,
    fill: "none",
    viewBox: "0 0 301 74",
    ...props,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <g clipPath="url(#clip0_252_2295)">
        <g transform="translate(65, 0)">
        <path
          d="M164.943 24.5962L154.059 0.35976L153.898 0L142.563 24.3406L142.443 24.5962H146.514L149.026 19.1146H158.452L160.819 24.5962H164.943ZM153.832 8.50484L156.909 15.5549H150.61L153.832 8.50484Z"
          fill="#040000"
        />
        <path
          d="M171.069 1.66943H167.304V24.5962H171.069V1.66943Z"
          fill="#040000"
        />
        <path
          d="M37.7685 9.2559H46.9076V5.794H37.576L37.3235 1.25598H33.8585L34.1109 5.794H25.6313V9.2559H34.3034L34.5685 14.0464H24.4353V17.5083H34.7642L35.1492 24.4321H38.6142L38.2292 17.5083H48.1005V14.0464H38.0367L37.7685 9.2559Z"
          fill="#040000"
        />
        <path
          d="M15.2141 13.7055C15.9967 12.5442 16.6942 11.3229 17.2906 10.0417C19.02 6.53875 19.3071 2.89697 19.3071 2.89697H1.47696V6.35887H15.0563C12.6484 13.2827 7.1479 18.6885 0.157837 20.9638V24.5772C5.185 23.1666 9.58732 20.3611 12.9514 16.6025C13.2228 16.9876 13.5447 17.4136 13.9297 17.868C16.003 20.3138 18.9127 22.5607 22.5734 24.5583V20.5662C17.7292 17.5903 15.8232 14.8006 15.2141 13.7055Z"
          fill="#040000"
        />
        <path
          d="M101.039 10.7581H97.7252L98.4132 15.4097H101.73L101.039 10.7581Z"
          fill="#040000"
        />
        <path
          d="M106.391 15.4097L105.703 10.7581H102.386L103.077 15.4097H106.391Z"
          fill="#040000"
        />
        <path
          d="M101.193 21.0869V24.4194C107.909 23.3402 113.11 17.6787 113.482 10.7581H110.194C109.84 15.8704 106.091 20.0613 101.19 21.0869H101.193Z"
          fill="#040000"
        />
        <path
          d="M53.7431 2.89697C53.7431 5.21332 53.7431 10.4488 53.68 13.7687C53.6452 15.7158 52.4113 18.799 50.1613 20.5504V24.5614C54.876 22.4976 57.0787 17.0444 57.1387 13.8318C57.2018 10.4866 57.205 5.22594 57.2018 2.89697H53.7399H53.7431Z"
          fill="#040000"
        />
        <path
          d="M63.3777 20.6388V2.89697H59.9158V24.4036L61.6515 24.3973C61.7745 24.3973 64.7378 24.3658 67.7421 22.3966C70.109 20.8439 72.9271 17.7923 73.8359 11.9004H70.3267C69.1969 18.0353 65.5741 20.0045 63.3777 20.6388Z"
          fill="#040000"
        />
        <path
          d="M133.329 1.13293C131.975 1.13293 130.782 1.83667 130.094 2.89702H112.46V6.35892H128.933C128.933 6.42834 128.939 6.49777 128.939 6.57035C128.939 14.4945 122.738 20.9418 115.117 20.9418V24.4037C123.95 24.4037 131.252 17.5304 132.275 8.6942C132.609 8.78887 132.963 8.84567 133.329 8.84567C135.456 8.84567 137.182 7.1163 137.182 4.9893C137.182 2.8623 135.453 1.13293 133.329 1.13293ZM133.329 6.17903C132.672 6.17903 132.136 5.64571 132.136 4.98615C132.136 4.32659 132.669 3.79326 133.329 3.79326C133.988 3.79326 134.522 4.32659 134.522 4.98615C134.522 5.64571 133.988 6.17903 133.329 6.17903Z"
          fill="#040000"
        />
        <path
          d="M74.3282 2.89697V6.35887H92.2499C91.6251 10.5308 89.5233 12.7336 85.5155 13.4436C85.7837 11.8373 85.831 10.3225 85.7395 9.10125H82.4764L82.2682 9.12018C82.2682 9.14543 82.508 11.8247 81.6717 14.6996C80.7881 17.7449 79.0714 19.8278 76.5593 20.9165V24.5962C80.8133 23.296 83.2338 20.279 84.5151 17.0601C90.7635 16.4668 94.3517 13.3332 95.5698 7.72217C96.1852 4.88827 95.9832 2.89697 95.9832 2.89697H74.3219H74.3282Z"
          fill="#040000"
        />
        </g>
        <path
          d="M0 40.7949V46.2229H26.6664V68.569H0V74.0001H32.9464V40.7949H0Z"
          fill="url(#paint0_radial_252_2295)"
        />
        <path
          d="M53.1402 53.2602L56.6431 48.2267C56.6431 48.2267 53.6167 46.0776 51.3446 44.727C49.0945 43.3889 44.1778 40.9337 44.1778 40.9337L40.8989 46.0114C40.8989 46.0114 45.7431 48.5139 47.99 49.833C50.24 51.1522 53.1402 53.2571 53.1402 53.2571V53.2602Z"
          fill="url(#paint1_radial_252_2295)"
        />
        <path
          d="M71.3238 44.3766L71.1661 44.3419L71.1345 44.4997C70.4055 48.1541 69.2694 51.3856 67.7641 54.1028C66.262 56.8136 64.3338 59.1457 62.0332 61.0202C59.7263 62.9074 56.9398 64.4253 53.7524 65.5362C50.5619 66.647 46.7971 67.4107 42.562 67.8052L42.3916 67.821L43.3604 73.5298L43.3825 73.6718L43.5308 73.6592C49.9308 73.0911 55.4976 71.6836 60.0703 69.4714C64.643 67.2561 68.37 64.1445 71.1471 60.2187C73.9179 56.2929 75.824 51.4267 76.8149 45.7526L76.8433 45.6042L71.3238 44.3766Z"
          fill="url(#paint2_radial_252_2295)"
        />
        <path
          d="M118.522 67.4266C115.802 64.6432 113.321 62.0744 110.942 59.5687C108.486 56.9904 105.921 54.2512 103.106 51.2027C102.042 49.9972 101.092 48.9936 100.285 48.211C99.4672 47.4221 98.7761 46.8382 98.1765 46.4311C97.5706 46.0083 96.9426 45.7211 96.3146 45.5759C95.6929 45.4308 94.9829 45.3613 94.2097 45.3613C93.405 45.3613 92.6728 45.4718 92.0322 45.6895C91.3916 45.9041 90.7541 46.2734 90.1293 46.7783C89.5044 47.2832 88.8322 47.9901 88.1222 48.8706C87.4121 49.7416 86.5916 50.8745 85.6039 52.3261C84.553 53.7746 83.3853 55.3904 82.1104 57.1608C80.8986 58.846 79.4659 60.8026 77.7239 63.1442L77.6355 63.2641L82.0946 67.0226L82.224 67.1331L82.3218 66.9942C83.8808 64.8515 85.2788 62.8949 86.478 61.175C87.7088 59.4077 88.7596 57.8677 89.6938 56.4665C90.7194 54.9928 91.4389 53.9861 91.9501 53.2981C92.4772 52.5849 92.919 52.1052 93.2598 51.8622C93.913 51.3889 94.4906 51.4047 95.2164 51.8244C95.5761 52.039 96.0684 52.4618 96.6744 53.0772C97.2771 53.6926 98.0913 54.5857 99.158 55.7975C100.613 57.4764 102.134 59.1742 103.68 60.8499C105.204 62.5004 106.852 64.2645 108.581 66.0885C110.175 67.7769 111.904 69.6009 113.763 71.5638L114.366 72.1981L118.525 67.6443L118.623 67.5339L118.522 67.4266Z"
          fill="url(#paint3_radial_252_2295)"
        />
        <path
          d="M108.865 50.7073C109.78 51.2532 110.797 51.5309 111.885 51.5309C112.974 51.5309 113.993 51.2532 114.902 50.7073C115.811 50.1613 116.543 49.4228 117.077 48.5108C117.61 47.5988 117.881 46.5826 117.881 45.4939C117.881 44.4052 117.619 43.3827 117.095 42.477C116.578 41.5618 115.852 40.8296 114.94 40.2963C114.025 39.763 112.996 39.4948 111.882 39.4948C110.793 39.4948 109.777 39.763 108.862 40.2963C107.953 40.8265 107.218 41.5618 106.669 42.4738C106.123 43.3858 105.845 44.3862 105.845 45.4529C105.845 46.5732 106.123 47.5988 106.669 48.5108C107.215 49.4228 107.953 50.1582 108.862 50.7073H108.865ZM110.377 43.9823C110.79 43.572 111.283 43.3732 111.885 43.3732C112.482 43.3732 112.987 43.5783 113.391 43.9823C113.795 44.3862 114 44.8943 114 45.4907C114 46.0967 113.801 46.589 113.391 46.9992C112.987 47.4031 112.479 47.6083 111.885 47.6083C111.283 47.6083 110.79 47.4095 110.377 46.9992C109.967 46.589 109.768 46.0967 109.768 45.4907C109.768 44.8911 109.973 44.3862 110.377 43.9823Z"
          fill="url(#paint4_radial_252_2295)"
        />
        <path
          d="M124.764 50.7955V56.2235H142.146V56.9178C142.146 60.2913 141.095 62.9863 139.022 64.9208C136.942 66.8585 133.783 68.0861 129.633 68.5626L129.453 68.5847L130.773 73.8675L130.807 74L130.94 73.9874C134.61 73.675 137.785 72.7945 140.379 71.3712C142.976 69.9417 144.993 67.9788 146.362 65.5362C147.735 63.0999 148.426 60.1998 148.426 56.9178V56.2235H162.911V50.7955H124.764Z"
          fill="url(#paint5_radial_252_2295)"
        />
        <path
          d="M158.48 38.7405H129.198V44.1684H158.48V38.7405Z"
          fill="url(#paint6_radial_252_2295)"
        />
        <path
          d="M187.864 47.8418L187.463 48.2805C186.27 49.5649 184.809 50.8335 183.121 52.0421C181.445 53.2445 179.602 54.3711 177.649 55.3936C175.733 56.3908 173.732 57.2555 171.709 57.9529C169.709 58.6377 167.771 59.1237 165.937 59.4014L165.42 59.4866L166.266 64.6653L166.78 64.5959C168.879 64.2771 171.069 63.728 173.294 62.9549C174.392 62.5762 175.49 62.1533 176.569 61.6957V74.0001H182.341V58.8082C183.61 58.0792 184.853 57.2839 186.037 56.4508C187.933 55.1159 189.59 53.7084 190.953 52.2725L191.288 51.9349L187.864 47.845V47.8418Z"
          fill="url(#paint7_radial_252_2295)"
        />
        <path
          d="M203.646 45.4939C205.176 45.8789 206.773 46.3175 208.392 46.7909C210.033 47.2737 211.75 47.8102 213.498 48.3877L213.647 48.4382L215.37 43.2817L215.218 43.2312C213.498 42.6442 211.791 42.1109 210.144 41.6312C208.49 41.1515 206.874 40.7129 205.344 40.3279C203.763 39.9302 202.074 39.5578 200.329 39.2202L200.194 39.1918L198.489 44.1779L198.426 44.3515L198.606 44.3862C200.373 44.7207 202.068 45.0931 203.646 45.4939Z"
          fill="url(#paint8_radial_252_2295)"
        />
        <path
          d="M205.18 56.4413C206.78 56.902 208.458 57.4353 210.178 58.016L210.327 58.0697L212.081 53.0646L212.138 52.9131L211.983 52.8595C210.235 52.2756 208.528 51.7455 206.909 51.2816C205.281 50.8177 203.709 50.4043 202.238 50.0445C200.717 49.6753 199.102 49.3029 197.442 48.9337L197.303 48.9021L195.681 53.8945L195.627 54.065L195.801 54.0997C197.502 54.4468 199.105 54.816 200.563 55.1884C202.03 55.5577 203.583 55.9805 205.183 56.4381L205.18 56.4413Z"
          fill="url(#paint9_radial_252_2295)"
        />
        <path
          d="M226.749 44.5188L226.727 44.6797C226.222 48.5898 225.266 52.0138 223.89 54.8603C222.511 57.6942 220.637 60.0768 218.308 61.9419C215.979 63.8101 213.094 65.2397 209.737 66.1959C206.369 67.1521 202.346 67.6949 197.783 67.8085H197.599L198.502 73.5394L198.644 73.5331C205.584 73.3059 211.482 72.154 216.168 70.1122C220.864 68.0641 224.597 64.9746 227.273 60.9383C229.943 56.9053 231.714 51.7361 232.54 45.5791L232.559 45.4245L226.749 44.5188Z"
          fill="url(#paint10_radial_252_2295)"
        />
        <path
          d="M236.75 52.9604V57.3691H254.252V61.0235H237.911V65.3564H254.252V69.5914H236.75V74.0001H259.314V52.9604H236.75Z"
          fill="url(#paint11_radial_252_2295)"
        />
        <path
          d="M276.955 53.2602L280.458 48.2267C280.458 48.2267 277.431 46.0776 275.159 44.727C272.909 43.3889 267.992 40.9337 267.992 40.9337L264.714 46.0114C264.714 46.0114 269.558 48.5139 271.805 49.833C274.055 51.1522 276.955 53.2571 276.955 53.2571V53.2602Z"
          fill="url(#paint12_radial_252_2295)"
        />
        <path
          d="M295.139 44.3766L294.981 44.3419L294.949 44.4997C294.22 48.1541 293.084 51.3856 291.579 54.1028C290.077 56.8136 288.148 59.1457 285.848 61.0202C283.541 62.9074 280.754 64.4253 277.567 65.5362C274.377 66.647 270.612 67.4107 266.377 67.8052L266.206 67.821L267.175 73.5298L267.197 73.6718L267.346 73.6592C273.745 73.0911 279.312 71.6836 283.885 69.4714C288.458 67.2561 292.185 64.1445 294.962 60.2187C297.733 56.2929 299.639 51.4267 300.63 45.7526L300.658 45.6042L295.139 44.3766Z"
          fill="url(#paint13_radial_252_2295)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3784) scale(35.6825 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="0.134" stopColor="#83E2E1" />
          <stop offset="0.288" stopColor="#79D4D5" />
          <stop offset="0.452" stopColor="#68BDC2" />
          <stop offset="0.623" stopColor="#509DA7" />
          <stop offset="0.8" stopColor="#317385" />
          <stop offset="0.978" stopColor="#0D415B" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3784) scale(35.6825 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3783) scale(35.6825 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3784) scale(35.6825 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3785) scale(35.6825 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3784) scale(35.6825 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3784) scale(35.6825 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3785) scale(35.6825 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3784) scale(35.6825 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3784) scale(35.6825 35.6824)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3785) scale(35.6825 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3784) scale(35.6824 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3784) scale(35.6824 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_252_2295"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(146.88 32.3783) scale(35.6825 35.6825)"
        >
          <stop stopColor="#87E7E5" />
          <stop offset="1" stopColor="#083B56" />
        </radialGradient>
        <clipPath id="clip0_252_2295">
          <rect width="300.655" height="74" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
